module.exports = __webpack_public_path__ + "img/grilled_cheese.de13ad08.jpg";